import React, { useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useHistory } from "react-router-dom"
import { toast } from "react-toastify"
import { useTranslation } from "react-i18next"

import {
  clearSiteData,
  createPrintRequest,
  isInKioskMode
} from "utils"
import { closeShift } from "services"
import { clearShift } from "@redux"
import { Button } from "components"
import classes from "./SccsmFooter.module.scss"
import clsx from "clsx"

const SccsmFooter = props => {
  const {
    printReport,
    expectedCashAmount,
    actualCashAmount,
    setActualCashAmount,
    setShowCloseShiftModal
  } = props

  const [t, i18n] = useTranslation()

  const history = useHistory()

  const dispatch = useDispatch()

  const {
    _id: accountId,
    fullName,
    mobilePhone,
    branchId
  } = useSelector(state => state.userAccountInfo)

  const printers = useSelector(state => state.printers)

  const shiftCashier = useSelector(state => state.shiftCashier)

  const [sending, setSending] = useState(false)

  const getRequestBody = () => {
    const {
      startingCash,
      startAt,
      paidIns,
      paidOuts,
      taxes,
      charges,
      refund,
      discounts,
      payments
    } = shiftCashier[accountId]

    const actualCash =
      Number(actualCashAmount)

    const diffrence =
      Math.round(actualCash - expectedCashAmount)

    return {
      branchId,
      startingCash,
      startAt,
      paidIns,
      paidOuts,
      taxes,
      charges,
      refund,
      discounts,
      payments,
      diffrence,
      actualCashAmount: actualCash
    }
  }

  const printShiftReport = async (shiftReport) => {
    const printerIndex =
      printers.findIndex(printer =>
        printer.forShiftReport
      )

    if (printerIndex === -1) {
      toast.error(
        t("هیچ_پرینتری_یافت_نشد_لطفا_در_قسمت_نتظیمات_پرینتر_گزینه_ی_پرینت_شیفت_را_برای_یک_پرینتر_فعال_کنید")
      )

      return
    }

    const printerSettings = printers[printerIndex]

    const printData = {
      ...shiftReport,
      fullName,
      mobilePhone
    }

    const request = {
      printType: "shift",
      printerIndex,
      printData,
      printerSettings,
      saveToFailedPrints: true
    }

    try {
      createPrintRequest(request)
    } catch (err) {
      console.log(err)
    }
  }

  const handleCloseShift = async () => {
    setSending(true)

    const data = getRequestBody()

    const shiftId = shiftCashier[accountId]._id

    try {
      const shift =
        await closeShift(shiftId, data)

      printReport &&
        printShiftReport({
          ...shift,
          payments: shift.payments || {},
          fullName
        })

      dispatch(clearShift())

      clearSiteData()

      history.push(kioskMode ? "/kiosk-languages" : "/foods")
    } catch (err) {
      console.log(err)

      const shiftHaveAlreadyClosed =
        err?.response?.data?.message === "Shift is already closed"

      if (shiftHaveAlreadyClosed) {
        dispatch(clearShift())

        clearSiteData()

        history.push(kioskMode ? "/kiosk-languages" : "/foods")

        toast.error(t("شیفت_قبلا_به_اتمام_رسیده"))

        return
      }

      toast.error(t("اتمام_شیفت_با_موفقیت_انجام_نشد"))

      setSending(false)
    }
  }

  useEffect(() => {
    setActualCashAmount(expectedCashAmount)
  }, [expectedCashAmount])

  const kioskMode = isInKioskMode()

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div className={classes["footer"]}>
      <Button
        color="danger"
        onClick={() => setShowCloseShiftModal(false)}
        disabled={sending}
        className={clsx(
          classes["button"],
          isLtr && classes["button-ltr"]
        )}
      >
        {t("انصراف")}
      </Button>

      <Button
        color="success"
        loading={sending}
        onClick={handleCloseShift}

      >
        {t("اتمام_شیفت")}
      </Button>
    </div>
  )
}

export default SccsmFooter